module.exports = __webpack_public_path__ + "media/images/number_26-b2ea80b317807902b761db5f047e226f.png";